import { Component, OnInit } from '@angular/core';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormGroup, FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';

import axios from 'src/app/Service/axios';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { OtherService } from 'src/app/Service/other.service';

import { animate, state, style, transition, trigger } from '@angular/animations';

import Feature from 'ol/Feature';

import { Icon, Style } from 'ol/style';

import { BingMaps, XYZ } from 'ol/source';

import TileLayer from 'ol/layer/Tile';

import VectorLayer from 'ol/layer/Vector';

import VectorSource from 'ol/source/Vector';

import * as olProj from 'ol/proj';

import { Point } from 'ol/geom';

import Vector from 'ol/source/Vector';

import Map from 'ol/Map';

import View from 'ol/View';

import OSM from 'ol/source/OSM';

declare let $: any;

@Component({

  selector: 'app-busy-routes',

  templateUrl: './busy-routes.component.html',

  styleUrls: ['./busy-routes.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class BusyRoutesComponent implements OnInit {

  lst_TripSAD: any = [];

  lst_Search: any = [];

  list_City: any[] = [];

  filteredCity: any = [];

  searchT_City = '';

  bEditMode: boolean = false;

  bMapMode: boolean = false;

  showFilter: boolean = false;

  mapMode: any;

  map: any;

  source: any;

  vector: any;

  layers: any = [];

  searchModel: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

  })

  mdl_TripSAD: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iTripSAD: new FormControl('-1'),

    fLat: new FormControl('', Validators.required),

    fLon: new FormControl('', Validators.required),

    strAddress: new FormControl('', Validators.required),

    strName: new FormControl('', Validators.required),

    strCity: new FormControl('', Validators.required),

    temp_mapMode: new FormControl(''),

    addressBar: new FormControl(''),

    temp_olongIn: new FormControl(''),

    temp_olatIn: new FormControl(''),

    indexTripSAD: new FormControl('')

  })

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    this.getTripSAD_List();

    this.getListCity();

  }

  async getTripSAD_List() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TripSAD_List`, this._otherService.stringNumberToNumber(this.searchModel.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_TripSAD = res;

    this.lst_Search = res;

  }

  filter_list(val: any) {

    this.lst_TripSAD = this.lst_Search.filter((el: any) => {

      return el.strName.includes(val.value) ||

        el.strCity.includes(val.value) ||

        el.strStateName.includes(val.value) ||

        el.strAddress.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_TripSAD = this.lst_Search;

    }

  }

  newTripSAD(bEdit: boolean = false, item: any = {}, index?: number) {

    this.bMapMode = false;

    this.bEditMode = bEdit;

    //  اگر در حالت ثبت بود

    if (!bEdit) {

      this.searchT_City = '';

      this.mdl_TripSAD.patchValue({

        iTripSAD: -1,

        fLat: '',

        fLon: '',

        strAddress: '',

        strName: '',

        strCity: '',

        temp_mapMode: '',

        addressBar: '',

        temp_olongIn: '',

        temp_olatIn: '',

        indexTripSAD: '',

      })

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#TripSAD_modal").modal('show');

    }

    // اگر در حالت ویرایش بود

    else {

      this.searchT_City = this.list_City.filter((el: any) => el.strCity.includes(item.strCity))[0].strCityName;

      this.mdl_TripSAD.get('indexTripSAD')?.setValue(index);

      Object.keys(item).forEach(key => {

        this.mdl_TripSAD.get(key)?.setValue(item[key])

      })

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#TripSAD_modal").modal('show');

    }

  }

  getListCity = async () => {

    this._otherService.Showspinner()

    let res = JSON.parse((await axios.post(`City_List`, this._otherService.stringNumberToNumber(this.searchModel.value))).data.toString());

    this._otherService.nonespinner()

    this.list_City = res;


  }

  selectedCity(item: any) {

    this.mdl_TripSAD.controls['strCity'].setValue(item.strCity)

    this.searchT_City = item.strCityName;

    this.filteredCity = [];

  }

  filterCity() {

    if (this.searchT_City == '') {

      this.filteredCity = [];

      this.mdl_TripSAD.controls['strCity'].setValue('')

    }

    else this.filteredCity = this.list_City.filter((item: any) => item.strCityName.includes(this.searchT_City));

  }

  hideCity_Option() {

    setTimeout(() => {

      this.filteredCity = [];

    }, 300);
  }

  async getLocationGeocoding(source: any, int: any, value: any) {

    var model = this._otherService.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

      strAddress: value

    })

    let res = JSON.parse((await axios.post(`Geocoding_FleetYar`, model)).data.toString());

    if (res.iResult == -1) {

      this.mdl_TripSAD.controls['fLat'].setValue(0)

      this.mdl_TripSAD.controls['fLon'].setValue(0)

      return this._tooltip.showError(res.strComment)

    };

    //  اگر کاربر در حالت جستجو بر روی نقشه نبود

    if (source == 0) {

      this.mdl_TripSAD.controls['fLat'].setValue(res.fLat)

      this.mdl_TripSAD.controls['fLon'].setValue(res.fLon)

      this.mdl_TripSAD.controls['strAddress'].setValue(res.strAddress);


    }

    // اگر کاربر در حالت جستجو بر روی نقشه بود

    else {

      this.mdl_TripSAD.controls['temp_olatIn'].setValue(res.fLat)

      this.mdl_TripSAD.controls['temp_olongIn'].setValue(res.fLon)

      this.mdl_TripSAD.controls['addressBar'].setValue(res.strAddress);

    }

    if (source == 1) {

      this.map.getLayers().forEach((layer: VectorSource) => {

        if (layer.getKeys().length < 11)

          this.map.removeLayer(layer);

      });

      var iconStyle = new Style({

        image: new Icon(({

          anchor: [0, 46],

          anchorXUnits: 'fraction',

          anchorYUnits: 'pixels',

          size: [48, 48],

          opacity: 1,

          src: '../../assets/Img/marker4.png'

        }))

      });

      var iconGeometry = new Point(olProj.fromLonLat([this.mdl_TripSAD.get('temp_olongIn')?.value, this.mdl_TripSAD.get('temp_olatIn')?.value]));

      var iconFeature = new Feature({

        geometry: iconGeometry,

      });

      iconFeature.setStyle(iconStyle);

      var vectorSource = new Vector({

        features: [iconFeature]

      });

      var dinamicPinLayer = new VectorLayer({

        source: vectorSource

      });


      this.map.addLayer(dinamicPinLayer);

      this.map.getView().setCenter(olProj.transform([this.mdl_TripSAD.get('temp_olongIn')?.value, this.mdl_TripSAD.get('temp_olatIn')?.value], 'EPSG:4326', 'EPSG:3857'))

      this.map.getView().getZoom() == 13 ? this.map.getView().animate({

        zoom: this.map.getView().getZoom() + 5,

        duration: 250

      }) : this.map.getView().animate({

        zoom: this.map.getView().getZoom() + 0,

        duration: 250

      })

    }

  }

  newOpenMap = (mode: number) => {

    this.mapMode = mode;

    $('#maplat').modal('show');

    setTimeout(() => {

      if (this.map) {

        this.map.setTarget(null);

      }

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      var iconStyle = new Style({
        
        image: new Icon(({
          
          anchor: [0, 46],
          
          anchorXUnits: 'fraction',
          
          anchorYUnits: 'pixels',
          
          size: [48, 48],
          
          opacity: 1,
          
          src: '../../assets/Img/marker4.png'
          
        }))
        
      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                              key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',


                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }

      if (this.mdl_TripSAD.get('fLat')?.value != '' && this.mdl_TripSAD.get('fLon')?.value != '' && this.mapMode == 0) {

        this.map = new Map({

          layers: this.layers,

          target: 'map',

          controls: [],

          view: new View({

            center: olProj.fromLonLat([this.mdl_TripSAD.get('fLon')?.value, this.mdl_TripSAD.get('fLat')?.value]),

            zoom: 18,

          }),

        });

        var iconGeometry = new Point(olProj.fromLonLat([this.mdl_TripSAD.get('fLon')?.value, this.mdl_TripSAD.get('fLat')?.value]))

        var iconFeature = new Feature({

          geometry: iconGeometry,

        });

        iconFeature.setStyle(iconStyle);

        var vectorSource = new Vector({

          features: [iconFeature]

        });

        var dinamicPinLayer = new VectorLayer({

          source: vectorSource

        });

        this.map.addLayer(dinamicPinLayer);

      }

      else {

        this.map = new Map({

          layers: this.layers,

          target: 'map',

          controls: [],

          view: new View({

            center: olProj.fromLonLat([51.3833554, 35.6770113]),

            zoom: 13,

          }),

        });

      }

      this.map.on('click', (e: any) => {

        if (e.dragging) return;

        var coords = olProj.toLonLat(e.coordinate);

        this.mdl_TripSAD.controls['temp_mapMode'].setValue(0)

        this.mdl_TripSAD.controls['temp_olatIn'].setValue(coords[1])

        this.mdl_TripSAD.controls['temp_olongIn'].setValue(coords[0])

        this.setReverseGeocode(this.mdl_TripSAD.controls['temp_olatIn'].value, this.mdl_TripSAD.controls['temp_olongIn'].value);

        var iconGeometry = new Point(e.coordinate);

        var iconFeature = new Feature({

          geometry: iconGeometry,

          properties: {

            name: 'mapMarker'

          }

        });

        iconFeature.setStyle(iconStyle);

        var vectorSource = new Vector({

          features: [iconFeature]

        });

        var dinamicPinLayer = new VectorLayer({

          source: vectorSource

        });

        this.map.getLayers().forEach((layer: VectorSource) => {

          if (layer.getKeys().length < 11) this.map.removeLayer(layer);

        });

        this.map.addLayer(dinamicPinLayer);

      })

      this.map.on('pointermove', (e: any) => {

        var pixel = this.map.getEventPixel(e.originalEvent);

        var hit = this.map.hasFeatureAtPixel(pixel);

        this.map.getViewport().style.cursor = 'pointer';

      });

    }, 500);

  }

  showOnMap(item: any) {

    this.mdl_TripSAD.controls['fLat'].setValue(item.fLat);

    this.mdl_TripSAD.controls['fLon'].setValue(item.fLon);

    this.newOpenMap(0);

    this.bMapMode = true;


  }

  async setReverseGeocode(lat: any, long: any) {

    let res = (await axios.post(`ReverseGeocoding_FleetYar`, {

      'fLat': lat,

      'fLon': long

    }));

    this.mdl_TripSAD.controls['addressBar'].setValue(res.data.strAddress);

  }

  confirmMap() {

    this.mdl_TripSAD.controls['fLat'].setValue(this.mdl_TripSAD.get('temp_olatIn')?.value)

    this.mdl_TripSAD.controls['fLon'].setValue(this.mdl_TripSAD.get('temp_olongIn')?.value)

    this.mdl_TripSAD.controls['strAddress'].setValue(this.mdl_TripSAD.get('addressBar')?.value);

    this.mdl_TripSAD.controls['addressBar'].setValue('');

    $("#maplat").modal('hide');

  }

  async addTripSAD() {

    if (this.mdl_TripSAD.invalid) return this._tooltip.showError('لطفا فرم را با دقت تکمیل کنید');

    //  اگر در حالت ثبت بود

    if (!this.bEditMode) {

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`TripSAD_Save`, this._otherService.stringNumberToNumber(this.mdl_TripSAD.value))).data.toString());

      this._otherService.nonespinner();

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.lst_TripSAD.push(res[0])

      this._tooltip.showSuccess('با موفقیت ثبت شد');

      $("#TripSAD_modal").modal('hide');

    }

    // اگر در حالت ویرایش بود

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this._otherService.Showspinner();

              let res = JSON.parse((await axios.post(`TripSAD_Edit`, this._otherService.stringNumberToNumber(this.mdl_TripSAD.value))).data.toString());

              this._otherService.nonespinner();

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.lst_TripSAD[this.mdl_TripSAD.get('indexTripSAD')?.value] = res[0];

              this._tooltip.showSuccess('با موفقیت ویرایش شد');

              $("#TripSAD_modal").modal('hide');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  removeTripSAD(item: any, index: number) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید؟ `,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this.mdl_TripSAD.get('indexTripSAD')?.setValue(index);

            Object.keys(item).forEach(key => {

              this.mdl_TripSAD.get(key)?.setValue(item[key])

            })

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`TripSAD_Delete`, this._otherService.stringNumberToNumber(this.mdl_TripSAD.value))).data.toString());

            this._otherService.nonespinner();

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            this.lst_TripSAD.splice(this.mdl_TripSAD.get('indexTripSAD')?.value, 1)

            this._tooltip.showSuccess('با موفقیت حذف شد');

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }


}
